const $window = $(window);
const $headerElements = $('.js-header-calc');
const $wrapper = $('.wrapper');
const $banner = $('.js-banner');
const $header = $('.js-header');
const $burger = $('.btn-burger');

/**
 * Scroll Passed Banner
 *
 * @return {Void}
 */
function scrollPassedBanner() {
  let bannerHeight = $banner.outerHeight();

  if (bannerHeight <= $window.scrollTop()) {
    return true;
  }

  return false;
}

/**
 * Position Header
 *
 * @return {Void}
 */
function positionHeader() {
  if (scrollPassedBanner()) {
    $header.css('position', 'fixed');
    $wrapper.css('padding-top', $header.outerHeight() + 'px');
  } else {

    if ($window.width() > 1024) {
      $header.css('position', 'relative');
    } else {
      $header.css('position', 'static');
    }
    $wrapper.css('padding-top', '0');
  }
}

positionHeader();

/**
 * Change Header Position on scroll
 *
 * @return {Void}
 */
$window.on('scroll', function() {
  if (! $burger.hasClass('btn-burger--triggered')) {
    positionHeader();
  }
})

/**
 * Add Cart toggle functionality to cart icons in header
 *
 * @return {Void}
 */
function toggleSideCartinHeader() {
  const headerCartTogglers = document.querySelectorAll(
    ".header__js-cart-toggle-trigger"
  );
  const burgerClose = document.querySelector(".js-close-burger");

  if (headerCartTogglers !== null && burgerClose !== null) {
    headerCartTogglers.forEach(toggler =>
      toggler.addEventListener("click", evt => {
        evt.preventDefault();
        burgerClose.click();
        Cart.toggle();
      })
    );
  }

}

toggleSideCartinHeader();